import { DecimalPipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';

import { LocaleService } from '../../locale.service';

@Pipe({ name: 'shortNumber' })
export class ShortNumberPipe extends DecimalPipe implements PipeTransform {
	constructor(public localeService: LocaleService) {
		super(localeService.locale);
	}

	transform(value = 0, digitsInfo?: string): string | null {
		const digits = 4;
		if (value === null) {
			return null;
		}
		if (value === 0) {
			return '--';
		}

		if (Math.floor(value).toString().length <= 5) {
			return super.transform(value, digitsInfo);
		}

		const isNegative = value < 0;
		const powers = [
			{ key: 'Q', value: Math.pow(10, 15) },
			{ key: 'T', value: Math.pow(10, 12) },
			{ key: 'B', value: Math.pow(10, 9) },
			{ key: 'M', value: Math.pow(10, 6) },
			{ key: 'K', value: 1000 }
		];

		let abs = Math.abs(value);
		let key = '';

		for (let i = 0; i < powers.length; i++) {
			const reduced = abs / powers[i].value;

			if (reduced >= 1) {
				const rounder = Math.pow(10, digits - Math.floor(reduced).toString().length);
				abs = Math.round(reduced * rounder) / rounder;
				key = powers[i].key;
				break;
			}
		}

		return (isNegative ? '-' : '') + abs + key;
	}
}